import { getFormData } from "../helpers/formData";
import { removeErrors } from "../helpers/removeErrors";
import { postData } from "../helpers/postData";
import { setErrors } from "../helpers/setErrors";
import { getIti } from "../components/intl-tel-mask";
import { closeModal, openModal } from "../components/modal";

const form = document.querySelector("[data-form]");

if (form) {
  form.addEventListener("submit", (e) => {
    e.preventDefault();
    const action = form.dataset.action;
    const data = getFormData(form);
    const btn = form.querySelector(".btn");

    removeErrors();
    btn.setAttribute("disabled", true);

    const iti = getIti();
    const phoneNumber = iti.getNumber();

    const newData = { ...data, phone: phoneNumber };

    postData(action, newData)
      .then((res) => {
        if (res?.status) {
            window.location.href = res.redirect_url;
        //   const modal = document.querySelector('[data-modal="success"]');
        //   const currentModal = form.closest('[data-modal="free-lesson"]');
        //   closeModal(currentModal);
        //   openModal(modal);
        //   form.reset();
        }

        if (res?.errors) {
          setErrors(res.errors, form);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => btn.removeAttribute("disabled"));
  });
}
